<ng-container *transloco="let t;">

  <p class="filename">
    <ng-container [ngSwitch]="report?.status">
      <ng-container *ngSwitchCase="'generating'">
        <fa-icon class="p-mr-1 p-mb-1" [icon]="faSpinner" [spin]="true" [pTooltip]="t('dashboard.resultreport.generating')"></fa-icon>
        {{ t('dashboard.resultreport.generating') }}
      </ng-container>
      <ng-container *ngSwitchCase="'draft'">
        {{ t('dashboard.resultreport.draft_text') }}
      </ng-container>
      <ng-container *ngSwitchCase="'progress'">
        {{ t('dashboard.resultreport.progress_text') }}
      </ng-container>
      <ng-container *ngSwitchCase="'finished'">
        {{ t('dashboard.resultreport.finished_text') }}
      </ng-container>
      <ng-container *ngSwitchCase="'error'">
        {{ t('dashboard.resultreport.error_text') }}
      </ng-container>
    </ng-container>
  </p>

  <p *ngIf="report?.status && report?.status !== 'generating' && report?.status !== 'finished'" class="p-mr-1 p-mb-1 filename">
    <a (click)="visible = true">{{ t('dashboard.resultreport.edit_report') }}</a>
  </p>
  <p *ngIf="!report?.status" class="p-mr-1 p-mb-1 filename">
    <a (click)="visible = true">{{ t('dashboard.resultreport.upload_report') }}</a>
  </p>
  <p *ngIf="report?.status === 'finished'" class="p-mr-1 p-mb-1 filename">
    <a (click)="downloadReport()">{{ t('dashboard.resultreport.download_report') }}</a>
  </p>

  <p-dialog header="{{ t('dashboard.resultreport.edit_report') }}" [(visible)]="visible" [draggable]="false" [resizable]="false" modal="true" appendTo="body" [style]="{width: '70vw'}" (onHide)="onClose()">

    <ng-container *ngIf="report?.public_name">
      <div class="p-grid">
        <div class="p-col-9">
          {{ report?.public_name }} <p-tag class="p-ml-2">{{ t('dashboard.resultreport.' + report.status) }}</p-tag>
        </div>
        <div class="p-col-3 p-text-right">
          <a (click)="downloadReport()">{{ t('dashboard.resultreport.download_' + (report?.status === 'draft' ? 'template' : 'report')) }}</a>
        </div>
      </div>
      <p *ngIf="report?.status !== 'finished' && report?.internal === true && !report?.can_finish" class="p-mt-4 p-pt-4 line-top">{{ t('dashboard.resultreport.finish_hint') }}</p>
    </ng-container>

    <p *ngIf="!report?.public_name">{{ t('dashboard.resultreport.no_report_available') }}</p>

    <input style="display: none" type="file" #fileInput (change)="onUploadFile(fileInput.files)" accept=".ppt,.pptx,.pdf" />

    <p-footer>
      <button *ngIf="report?.status !== 'finished'" pButton (click)="uploadReport()" [disabled]="busy" [label]="t('common.labels.upload')" icon="pi pi-upload"></button>
      <button *ngIf="report?.status !== 'finished' && report?.internal === true" pButton (click)="finishReport()" [disabled]="busy || !report?.can_finish" [label]="t('common.labels.finish')" icon="pi pi-lock"></button>
    </p-footer>

  </p-dialog>

</ng-container>
